module.exports = __webpack_public_path__ + "media/images/app/homepage/occasions/everyday-b74633749c734dc25fa963edb902521b.webp";